import { delegatedObserver } from "../dom/dom";
import { getWeek } from "../util/util";
import { ControlOptions, UIControl } from "./control";
import { completeWeekValue, Week, WeekPicker, WeekPickerOptions } from "./temporal-pickers";


/**@interface
@param startWithCurrentWeek optional start the control with the current week, defaults to true
 */
export interface WeekControlOptions extends ControlOptions {
	startWithCurrentWeek?: boolean
}


export class WeekControl extends UIControl<Week> {

	private weekPicker: WeekPicker;

	public constructor(options: ControlOptions) {
		super(options);
		if (this.getOptions().startWithCurrentWeek !== false)
			this.setValue(new Date());
	}

	/**@override */
	public getOptions(): WeekControlOptions {
		return super.getOptions();
	}

	protected build(): void {

		this.subscribe({
			next: _weekValue => {
				this.updateValueLabels();
				console.log('WeekControl value changed to  ' + JSON.stringify(this.getValue()));
			}
		});

		const weekPickerOptions: WeekPickerOptions = {
			parent: this.getContainer(),
			selector: 'div.tlmd-picker',
			weekRangeSelector: 'div.tlmd-picker-week.selected-value',
			yearControl: {
				selector: 'div.tlmd-picker-week.year-control',
				labelSelector: 'div.year-control-label span.year-value',
				buttonsSelector: 'div.year-control-buttons'
			}
		}
		this.weekPicker = new WeekPicker(weekPickerOptions);


		this.addSubscription(
			delegatedObserver(this.getContainer(), 'click', 'span.tlmd-button.open')
				.subscribe(_evAndTrgt => {
					this.weekPicker.open();
				}));

		this.weekPicker.setValue(new Date());

		this.weekPicker.subscribe({
			next: weekValue => {
				this.weekPicker.close();
				this.setValue(weekValue);
			}
		});

		this.updateValueLabels();
	}

	private updateValueLabels() {
		if (this.getValue()) {
			this.getContainer().querySelector('span.tlmd-button.year').innerHTML = String(this.getValue().year);
			this.getContainer().querySelector('span.tlmd-button.week').innerHTML = String(this.getValue().week).padStart(2, '0');
		} else {
			this.getContainer().querySelector('span.tlmd-button.year').innerHTML = '----';
			this.getContainer().querySelector('span.tlmd-button.week').innerHTML = '--';
		}
		if (this.weekPicker) {
			this.weekPicker.setValue(this.getValue());
		}
	}

	public setValue(value: Week | Date): WeekControl {
		let weekValue: Week;
		if (value !== undefined && (<Date>value).toLocaleTimeString) {
			const date = value ? (<Date>value) : new Date();
			weekValue = <Week>getWeek(date);
		} else {
			weekValue = <Week>value;
		}
		super.setValue(completeWeekValue(weekValue));
		return this;
	}

	public release(): WeekControl {
		super.release();
		this.weekPicker.release();
		return this;
	}

}
